import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useAuthStore } from '../store/authStore';

interface LoginForm {
  username: string;
  password: string;
}

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading, error } = useAuthStore();
  const [loginError, setLoginError] = useState<string | null>(null);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginForm>();

  const onSubmit = async (data: LoginForm) => {
    try {
      setLoginError(null);
      await login(data.username, data.password);
      navigate('/');
    } catch (error: any) {
      if (error.message === 'Accès réservé aux professeurs') {
        setLoginError('Accès réservé aux professeurs. Les administrateurs doivent utiliser l\'interface d\'administration.');
      } else {
        setLoginError(error.response?.data?.error || 'Identifiants invalides');
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Plateforme Éducative
          </Typography>
          <Typography component="h2" variant="h6" align="center" color="textSecondary" gutterBottom>
            Espace Professeurs
          </Typography>
          
          {(loginError || error) && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {loginError || error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 3 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Nom d'utilisateur"
              autoComplete="username"
              autoFocus
              {...register('username', {
                required: 'Le nom d\'utilisateur est requis',
              })}
              error={!!errors.username}
              helperText={errors.username?.message}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Mot de passe"
              type="password"
              id="password"
              autoComplete="current-password"
              {...register('password', {
                required: 'Le mot de passe est requis',
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={isLoading}
            >
              {isLoading ? <CircularProgress size={24} /> : 'Se connecter'}
            </Button>
          </Box>

          <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 2 }}>
            Identifiants de test : admin / admin123
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;